import { Phone, FileText } from "lucide-react";
import { BUSINESS } from "../data/business";

export default function MobileStickyCTA() {
  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-50 px-3 pb-3 pt-2 bg-gradient-to-t from-white via-white/95 to-white/0"
      data-testid="mobile-sticky-cta"
    >
      <div className="flex gap-2 rounded-2xl shadow-lg bg-white border border-slate-200 p-2">
        <a
          href={BUSINESS.phoneHref}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-[#1E3A8A] text-white font-semibold py-3"
          data-testid="sticky-call-btn"
        >
          <Phone size={16} /> Call Now
        </a>
        <a
          href="#quote"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-[#047857] text-white font-semibold py-3"
          data-testid="sticky-quote-btn"
        >
          <FileText size={16} /> Free Quote
        </a>
      </div>
    </div>
  );
}
